import script from "./functional-locations.vue?vue&type=script&setup=true&lang=ts"
export * from "./functional-locations.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__